export enum AppStartPreviewMode {
    keyPair = 'keyPair',
    diff = 'diff',
    none = 'none',
}

export enum AppStartPlaybackMode {
    url = 'url',
    apk = 'apk'
}